import React from 'react';

export const DeploymentIcon: React.FC = () => (
<svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M50 100C77.6142 100 100 77.6143 100 50C100 22.3858 77.6142 0 50 0C22.3858 0 0 22.3858 0 50C0 77.6143 22.3858 100 50 100Z" fill="#2A4CA4"/>
<path d="M23 76V64H77V76H23ZM29 73H35V67H29V73ZM23 40V28H77V40H23ZM29 37H35V31H29V37ZM23 58V46H77V58H23ZM29 55H35V49H29V55Z" fill="white"/>
</svg>
);

